import { TFunction } from 'i18next';

export const getDescriptionBenefits = (data: {
  t: TFunction;
  isTrial: boolean;
}): string[] => {
  const { t, isTrial } = data;

  return [
    t('modal:upgrade_sub.benefits[0]', 'Unlimited Words For All Tools'),
    t(
      'modal:upgrade_sub.benefits[1]',
      'Early Access To New AI Models And Features',
    ),
    t('modal:upgrade_sub.benefits[2]', 'Unlimited Image Generations'),
    ...(isTrial
      ? [t('modal:upgrade_sub.benefits[3]', 'Increased input limits')]
      : []),
  ];
};
